import React from 'react';
import * as RadixTabsPrimitive from '@radix-ui/react-tabs';
import {
  styled,
  GenesisCoreInspector,
  GDSCustomizableComponent,
  Tabs,
} from '@leagueplatform/genesis-core';

export interface ControlList {
  title: string;
  id: string;
}
export interface GDSSegmentProps
  extends RadixTabsPrimitive.TabsProps,
    GDSCustomizableComponent {
  defaultSelectedControlId: string;
  segmentedControlName: string;
}

export const DISPLAY_NAME = 'SegmentedControl';

export const BaseSegmentedRoot = styled(Tabs.Root, {
  width: 'fit-content',
  backgroundColor: '$surfaceBackgroundPrimary',
  border: '1px solid $onSurfaceBorderSubdued',
  borderRadius: '$pill',
  padding: '$half',
  boxShadow: '$card',
});

export const SegmentedControlRoot = ({
  children,
  className,
  css,
  segmentedControlName,
  defaultSelectedControlId,
  'data-testid': testId = `GDS-${DISPLAY_NAME}`,
  ...props
}: GDSSegmentProps) => {
  const [toggleValue, setToggleValue] = React.useState<string>(
    defaultSelectedControlId,
  );

  const onValueChange = React.useCallback((id: string) => {
    if (id) {
      setToggleValue(id);
    }
  }, []);

  return (
    <GenesisCoreInspector displayName={DISPLAY_NAME}>
      <Tabs.Root
        className={[`GDS-segment-control`, className].join(' ')}
        css={css}
        aria-describedby={segmentedControlName}
        defaultValue={defaultSelectedControlId}
        value={toggleValue}
        onValueChange={onValueChange}
        data-testid={testId}
        {...props}
      >
        {children}
      </Tabs.Root>
    </GenesisCoreInspector>
  );
};

SegmentedControlRoot.displayName = DISPLAY_NAME;
